import React from 'react';

type IconProps = {
    width?: number;
    height?: number;
};

const IconRocket: React.FC<IconProps> = ({ width = 21, height = 20 }) => {
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width={width}
            height={height}
            viewBox="0 0 21 20"
            fill="none"
        >
            <g clip-path="url(#clip0_11498_32268)">
                <path
                    d="M15.1805 8.8195C17.0555 6.9445 17.1727 4.71403 17.1141 3.7195C17.1043 3.56792 17.0397 3.42508 16.9323 3.31767C16.8249 3.21027 16.682 3.14565 16.5305 3.1359C15.5359 3.07731 13.307 3.19293 11.4305 5.0695L6.5 9.99996L10.25 13.75L15.1805 8.8195Z"
                    stroke="#23262A"
                    stroke-width="1.25"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                />
                <path
                    d="M10.874 5.625H6.05757C5.89203 5.62508 5.73329 5.69082 5.61617 5.80781L2.93257 8.49141C2.85064 8.57352 2.79317 8.67682 2.76661 8.78974C2.74004 8.90265 2.74543 9.02074 2.78216 9.13077C2.81889 9.2408 2.88552 9.33844 2.97459 9.41275C3.06366 9.48707 3.17165 9.53513 3.28648 9.55156L6.49898 10"
                    stroke="#23262A"
                    stroke-width="1.25"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                />
                <path
                    d="M14.625 9.375V14.1914C14.6249 14.3569 14.5592 14.5157 14.4422 14.6328L11.7586 17.3164C11.6765 17.3983 11.5732 17.4558 11.4603 17.4824C11.3473 17.5089 11.2293 17.5036 11.1192 17.4668C11.0092 17.4301 10.9116 17.3635 10.8372 17.2744C10.7629 17.1853 10.7149 17.0773 10.6984 16.9625L10.25 13.75"
                    stroke="#23262A"
                    stroke-width="1.25"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                />
                <path
                    d="M7.6375 14.6742C7.33516 15.3375 6.31641 16.8758 3.375 16.8758C3.375 13.9344 4.91328 12.9156 5.57656 12.6133"
                    stroke="#23262A"
                    stroke-width="1.25"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                />
            </g>
            <defs>
                <clipPath id="clip0_11498_32268">
                    <rect width="20" height="20" fill="white" transform="translate(0.25)" />
                </clipPath>
            </defs>
        </svg>
    );
};

export default IconRocket;
